module.exports = __webpack_public_path__ + "img/fish-active.eec03560.png";